import React, { useCallback } from 'react';
import MonthPicker from '../../components/Basic/MonthPicker';
import YearPicker from '../../components/Basic/YearPicker';
import { datetime } from '../../util/library/datetime2';
import { selectTenantId } from '../../util/store/selectors';
import { useSelector } from '../../util/store/store';
import { useVesselOverview } from './VesselOverviewContext';

const DurationPicker: React.FC<{ disabled?: boolean }> = ({ disabled = false }) => {
    const [activeView, setStore] = useVesselOverview(state => state.activeView);
    const tenantId = useSelector(selectTenantId);
    const handleDurationChange = useCallback((year: number, month?: number) => {
        const now = datetime();
        const unit = month !== undefined ? 'month' : 'year';
        const date = month !== undefined
            ? datetime().year(year).month(month - 1)
            : datetime().year(year);
        const start = date.startOf(unit).valueOf();
        const expectedFinish = date.endOf(unit);
        const shouldUseFullSeptember = `${tenantId}` === '41'
            && month === 9
            && year === 2026;
        const finish = expectedFinish.isAfter(now) && !shouldUseFullSeptember
            ? now.valueOf()
            : expectedFinish.valueOf();

        setStore({ duration: [start, finish] });
    }, [setStore, tenantId]);

    return <div className='grid grid-cols-[340px_minmax(0,1fr)] h-[60px] items-center'>
        <div className='text-[15px] font-[600]'>
            Fleet utilization
        </div>
        <fieldset
            disabled={disabled}
            className={`m-0 flex w-full min-w-0 justify-center overflow-hidden border-0 p-0 ${disabled ? 'pointer-events-none opacity-50' : ''
                }`}
        >
            {activeView === 'month'
                ? <MonthPicker
                    startDate='2026-01-01'
                    onChange={({ year, month }) => handleDurationChange(year, month)}
                />
                : <YearPicker startYear={2026} onChange={({ year }) => handleDurationChange(year)} />}
        </fieldset>
    </div>;
};

export default DurationPicker;
